import type { ICurrentUserValues } from '$/hooks/useCurrentUser';
import type { ISettingsPageProps } from '$/pages/settings';

import {
  faChevronRight,
  faUserCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';

import theme from '$/assets/theme';
import HeadContentSection from '$/components/blocks/HeadContentSection';
import SettingsPage from '$/components/blocks/SettingsPage';
import Button from '$/components/elements/Button';
import ButtonContainer from '$/components/elements/ButtonContainer';
import ContactPanel from '$/components/elements/ContactPanel';
import Container from '$/components/elements/Container';

interface ISettingsPageViewProps
  extends ISettingsPageProps,
    ICurrentUserValues {}

const settingsButton = {
  buttonProps: {
    style: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      borderBottom: `1px solid ${theme.colors.grey2}`,
      justifyContent: 'unset',
      alignItems: 'unset',
      color: theme.colors.grey8,
      padding: '16px 0',
    },
  },
  iconContainerProps: {
    style: {
      alignItems: 'flex-start',
      paddingTop: '5px',
    },
  },
  textProps: {
    style: {
      textAlign: 'left',
    },
  },
};

const buttons: { title: string; description: string; href: string }[] = [
  {
    title: 'Persönliche Daten',
    description: 'Name, Geburtsdatum, Nationalität, Kinder',
    href: '/settings/personal-info',
  },
  {
    title: 'Anschrift & Kontakt',
    description: 'Adresse, E-Mail und Telefon',
    href: '/settings/contact',
  },
  {
    title: 'Bankverbindung',
    description: 'Deine Bankverbindung',
    href: '/settings/bank-details',
  },
];

const contractDetailsButton = {
  title: 'Vertragsdetails',
  description: 'Deine aktuellen Vertragsdetails',
  href: '/settings/contract-details',
};

const SettingsPageView = (props: ISettingsPageViewProps) => {
  const { enableContractDetailsPage } = useFlags();
  let buttonsData = [...buttons];
  if (enableContractDetailsPage) {
    buttonsData = [...buttons, contractDetailsButton];
  }

  return (
    <SettingsPage>
      <Container>
        <HeadContentSection.Title
          bold
          as="h1"
          color="grey7"
          style={{ display: 'block' }}
        >
          <span>Deine </span>
          <HeadContentSection.Underline>Daten</HeadContentSection.Underline>
        </HeadContentSection.Title>
        <ButtonContainer columns="1fr" style={{ margin: '24px 0 40px' }}>
          {buttonsData.map((buttonProps) => (
            <Button
              key={buttonProps.title}
              title={
                <>
                  <SettingsPage.ButtonHeaderText>
                    {buttonProps.title}
                  </SettingsPage.ButtonHeaderText>
                  <SettingsPage.ButtonDescriptionText>
                    {buttonProps.description}
                  </SettingsPage.ButtonDescriptionText>
                </>
              }
              variant="trueTransparent"
              textProps={settingsButton.textProps}
              buttonProps={settingsButton.buttonProps}
              iconContainerProps={settingsButton.iconContainerProps}
              leftIcon={<FontAwesomeIcon icon={faUserCircle} />}
              rightIcon={<FontAwesomeIcon icon={faChevronRight} />}
              link={{
                href: buttonProps.href,
              }}
            />
          ))}
        </ButtonContainer>
        <ContactPanel />
      </Container>
    </SettingsPage>
  );
};

export default SettingsPageView;
